export interface AnnouncementChannelsShape {
  modal: boolean
  bar: boolean
  email: boolean
}

export type AnnouncementBarContentSegment =
  | { type: 'text'; text: string }
  | { type: 'link'; text: string; url: string }

export const normalizeAnnouncementChannels = (
  raw: unknown
): AnnouncementChannelsShape => {
  if (!raw) {
    return { modal: false, bar: false, email: false }
  }

  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      return {
        modal: Boolean(parsed?.modal),
        bar: Boolean(parsed?.bar),
        email: Boolean(parsed?.email),
      }
    } catch {
      return { modal: false, bar: false, email: false }
    }
  }

  const source = raw as Record<string, unknown>
  return {
    modal: Boolean(source.modal),
    bar: Boolean(source.bar),
    email: Boolean(source.email),
  }
}

export const normalizeAnnouncementBarContent = (
  raw: unknown
): AnnouncementBarContentSegment[] | undefined => {
  if (!raw) {
    return undefined
  }

  if (Array.isArray(raw)) {
    return raw as AnnouncementBarContentSegment[]
  }

  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed)
        ? (parsed as AnnouncementBarContentSegment[])
        : undefined
    } catch {
      return undefined
    }
  }

  return undefined
}
